import React, { useState, useEffect } from 'react';
import { IdResult, IdInfo, CatTopic, CatTitle, BtnDownload, InpNumber, InpCheckbox, InpRadio, InfoPulse, BtnUpload, BtnCreate, ColLow, Cols, ColContainer, SingleRow, GroupBox, GroupContainer, InpRadioGroup } from '../components/component';
import { CatHeadline } from '../components/component.js';
import { DefaultLink, DefaultMessage, DefaultColormodes } from '../components/jptr-default.js';
import { CloudStrike } from '../base/clrsplt-CloudConnect';


const estimateGridsize = (num_colors, max_gridpoints) => {
    return Math.floor(Math.pow(max_gridpoints, 1 / num_colors));
};

const gridSizeNum = (gridUsed, gridSize, numColors) => {

    //console.log('gridSizeNum', gridUsed, gridSize, numColors);

    if (!gridUsed) {
        //console.log('return gridUsed', gridUsed, gridSize);  
        return gridSize;
    }

    let gsize = estimateGridsize(4, 300000) + 1;
    //let gsize = 4;
    if (numColors === 1) {
        gsize = 256; // w16
    }
    if (numColors === 3) {
        //gsize = 9; // w27
        //gsize = 16; // w64
        gsize = 25; // w125
        //gsize = 2;
    }
    if (numColors === 4) {
        gsize = 8; // w64
        //gsize = 17; // w289
        //gsize = 25; // w625
        //gsize = 2;
    }

    //console.log('return gsize calculated: ', gsize);

    return gsize;
}

function SpyPage({ name, filename, onClick }) {

    const handleOnClick = () => {
        onClick(filename);
    };

    return (
        <div className='spypage nully' onClick={handleOnClick}>
            <p><strong>{name}</strong><br /><small>SpyPage</small></p>
        </div>
    );
}


export default function Cntntspy() {

    // --- Spyimage ---

    const [imageId, setImageId] = useState(DefaultLink.ID);
    const [imageInfo, setImageInfo] = useState(DefaultLink.INFOSPYIMAGE);
    const [downloadableImage, setDownloadableImage] = useState(false);

    const [gridSize, setGridSize] = useState(8);
    const handleGridsizeChange = (value) => {
        setGridSize(value);
        setImageId(DefaultLink.ID);
    }

    const [selectedColormode, setSelectedColormode] = useState('CMYK (4C)');
    const handleColormodeChange = (event) => {
        setSelectedColormode(event.target.value);
        setImageId(DefaultLink.ID);
    };

    /*     const [scalable, setScalable] = useState(false);
        const handelScalableChange = (value) => {
            setScalable(value);
            setImageId(DefaultLink.ID);
        }; */

    const [resolution, setResolution] = useState(300);
    const handleResolutionChange = (value) => {
        setResolution(value);
        setImageId(DefaultLink.ID);
    };

    const [defaultGridsize, setDefaultGridsize] = useState(true);
    const handleDefaultGridsizeChange = (value) => {
        setDefaultGridsize(value);
        setImageId(DefaultLink.ID);
    };

    useEffect(() => {
        if (imageId === DefaultLink.ID || imageId === DefaultMessage.MESSAGE.calculating) {
            setDownloadableImage(false);
            setImageInfo(DefaultLink.INFOSPYIMAGE);
            return;
        }
        setDownloadableImage(true);
    }, [imageId, setDownloadableImage, setImageInfo]);



    const handleCreateImage = () => {

        const getEntry = DefaultColormodes.colormodes.find((colormodes) => colormodes.value.uiName === selectedColormode);

        if (!getEntry) {
            console.error(`No entry found for ${selectedColormode}!`);
            return;
        }
        const { channel, name } = getEntry.value;
        const gridsize = gridSizeNum(defaultGridsize, gridSize, channel);

        setImageId(DefaultMessage.MESSAGE.calculating);

        fetch('https://jupiterapi.colorspace.cloud/link/spyimage', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                //"name": spyName.value,
                "gridsize": gridsize,
                "num_colors": channel,
                "dpi": resolution,
                "colormode": name
            }),
            redirect: "follow"
        })
            .then(response => response.json())
            .then(data => {
                setImageId(data.file_id);
                setImageInfo({
                    filesize: data.bytes,
                    combinations: data.num_combinations,
                    dimension: `${data.info.pixel_width} x ${data.info.pixel_height} Pixel`,
                    duration: data.duration
                });
            })
            .catch(error => { console.error('Error:', error); })
    };

    const handleDownloadImage = async () => {
        const strike = new CloudStrike();
        await strike.downloadFile(imageId, 'tif')
            .catch((error) => {
                console.error('Error:', error);
            })
    };

    // --- Spypages ---

    const [visiPage, setVisiPage] = useState('hidden');
    const handleDownloadPage = (page) => {
        console.log('downloadPage', page);
        setVisiPage('visible');

        const strike = new CloudStrike();
        strike.downloadPage(page)
            .catch((error) => {
                console.log('downloadPage', error);
            })
            .finally(() => {
                setVisiPage('hidden');
            });
    };

    // --- Spylink ---

    const [linkId, setLinkIdLink] = useState(DefaultLink.ID);
    const [linkInfo, setLinkInfo] = useState(DefaultLink.INFOSPYLINK);
    const [downlaodableLink, setDownloadableLink] = useState(false);

    const [uploadInfo, setUploadInfo] = useState({
        name: 'No file selected',
        size: 0,
        type: 'No type selected'
    });

    useEffect(() => {
        if (linkId === DefaultLink.ID || linkId === DefaultMessage.MESSAGE.calculating) {
            setLinkInfo(DefaultLink.INFOSPYLINK);
            setDownloadableLink(false);
            return;
        }
        setDownloadableLink(true);
    }, [linkId, setLinkInfo, setDownloadableLink]);

    const handleUpload = (file) => {
        setUploadInfo({
            name: file.name,
            filesize: file.size,
            type: file.type
        });

        setLinkIdLink(DefaultMessage.MESSAGE.calculating);

        const strike = new CloudStrike();
        strike.uploadFile(file)
            .then((data) => { return data.file_id; })
            .then(async (id) => {
                const nameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
                const spyResult = await createSpyLink(id, nameWithoutExtension);

                console.log('spyResult', spyResult);

                setLinkIdLink(spyResult.body.fileID);
                setLinkInfo({
                    filesize: spyResult.body.filesize,
                    input: 'unknown',//spyResult.body.input_type,
                    output: spyResult.body.output_type,
                    duration: spyResult.body.elapsed
                });

                localStorage.setItem('jptr-id-link', spyResult.body.fileID);
            })
            .catch((error) => { console.error('Error:', error); })
    };

    // könnte auch in CloudStrike.js als Methode implementiert werden !!!
    async function createSpyLink(fileObjectId, linkName) {

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "fileID": fileObjectId,
                "name": linkName
            }),
            redirect: "follow"
        };

        const strike = new CloudStrike();
        return strike.sendRequest('/link/spylink', requestOptions)
            .catch((error) => { throw error; });
    }

    const handleDownloadLink = async () => {
        const strike = new CloudStrike();
        await strike.downloadLink(linkId, CloudStrike.LINK_TYPE.spyLink)
            .catch((error) => {
                console.error('Error:', error);
            })
    };

    return (
        <div className="flx-2row">
            <ColContainer>
                <GroupContainer>
                    <ColContainer>

                        <ColLow>
                            <CatTopic name="Spyimage" />
                            <p>Select your colormode and channel count to create a spyimage.</p>
                        </ColLow>

                        <GroupBox style={{ maxWidth: '100%' }}>
                            <div className="flx-Ht-6">

                                <Cols>
                                    <ColLow>
                                        <CatTitle name="Colormode" />
                                        <InpRadioGroup>
                                            {DefaultColormodes.colormodes.map((colormode) => (
                                                <InpRadio
                                                    group="spylink_mode"
                                                    value={colormode.value.uiName}
                                                    checked={selectedColormode === colormode.value.uiName}
                                                    onChange={handleColormodeChange}
                                                />
                                            ))}
                                        </InpRadioGroup>
                                    </ColLow>
                                </Cols>

                                <Cols>
                                    <ColLow>
                                        <CatTitle name="Resolution" />
                                        <InpNumber name="DPI" value={resolution} onChange={handleResolutionChange} />
                                    </ColLow>

                                    <ColLow>
                                        <CatTitle name="Gridsize" />
                                        <SingleRow>
                                            <InpCheckbox name="Default" value={defaultGridsize} onChange={handleDefaultGridsizeChange} />
                                            <InpNumber name="Gridsize" value={gridSize} onChange={handleGridsizeChange} disabled={defaultGridsize} />
                                        </SingleRow>
                                    </ColLow>

                                    {/* 
                                    <ColLow>
                                        <CatTitle name="Image spezification" />
                                        <InpCheckbox name="Scalable image" value={scalable} onChange={handelScalableChange} disabled={false} /> 
                                    </ColLow>    
                                    */}
                                </Cols>

                            </div>
                            <BtnCreate onClick={handleCreateImage} />
                        </GroupBox>

                        <Cols>
                            <IdResult linkId={imageId} />
                            <IdInfo labelText='Information Spyimage' {...imageInfo} />
                            <BtnDownload label='Spyimage' isDisabled={downloadableImage} onDownload={handleDownloadImage} />
                        </Cols>

                    </ColContainer>
                </GroupContainer>

                <GroupContainer>
                    <ColContainer>

                        <Cols>
                            <ColLow>
                                <CatTopic name="Spypages" />
                                <p>Download readymade SpyPages.</p>
                            </ColLow>

                            <SingleRow>
                                <SpyPage name="GRAY" filename="Spypage_GRAY" onClick={handleDownloadPage} />
                                <SpyPage name="RGB" filename="Spypage_RGB" onClick={handleDownloadPage} />
                                <SpyPage name="CMYK" filename="Spypage_CMYK" onClick={handleDownloadPage} />
                                <SpyPage name="LAB" filename="Spypage_LAB" onClick={handleDownloadPage} />
                                <InfoPulse visible={visiPage} info={DefaultMessage.MESSAGE.downloading} />
                            </SingleRow>
                        </Cols>
                    </ColContainer>
                </GroupContainer>
            </ColContainer>

            <ColContainer>
                <ColLow>
                    <CatHeadline name="Spylink" />
                    <p>
                        The spylink has a unique ID that you can share with others or download as an ICC-Profile.
                        After uploading a spyimgae or a spypage it will be automatically created.
                    </p>
                </ColLow>
                <GroupBox style={{ maxWidth: '100%' }}>
                    <Cols>
                        <IdInfo labelText='Info Upload' {...uploadInfo} />
                        <BtnUpload label='Spyimage' onUpload={handleUpload} />
                    </Cols>
                </GroupBox>
                <Cols>
                    <IdResult linkId={linkId} />
                    <IdInfo labelText='Info Spylink' {...linkInfo} />
                    <BtnDownload label='Spylink' isDisabled={downlaodableLink} onDownload={handleDownloadLink} />
                </Cols>
            </ColContainer>

        </div>
    );
}